module.exports = __webpack_public_path__ + "img/chofu_watch_off.426be72b.svg";